import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/translation.json';
import ru from './locales/ru/translation.json';
import ky from './locales/ky/translation.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            ky: { translation: ky },
            en: { translation: en },
            ru: { translation: ru },
        },
        lng: 'ky',
        fallbackLng: 'en',
        interpolation: { escapeValue: false },
    });

export default i18n;
